var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperatingTheatre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4261 1.52344H2.65689C2.22167 1.52344 1.80427 1.69633 1.49651 2.00408C1.18876 2.31183 1.01587 2.72924 1.01587 3.16446V21.2157C1.01587 21.651 1.18876 22.0684 1.49651 22.3761C1.80427 22.6839 2.22167 22.8568 2.65689 22.8568H17.4261C17.8614 22.8568 18.2788 22.6839 18.5865 22.3761C18.8943 22.0684 19.0672 21.651 19.0672 21.2157V3.16446C19.0672 2.72924 18.8943 2.31183 18.5865 2.00408C18.2788 1.69633 17.8614 1.52344 17.4261 1.52344Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0415 1.52344V22.8568",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1441 11.3691V13.0102",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93896 11.3691V13.0102",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingTheatre);
export default __webpack_public_path__ + "static/media/operating_theatre.aa84baaa85359a6fd2cae1ec2d1d80a9.svg";
export { ForwardRef as ReactComponent };